<template>
	<div>
		<div class="searchTop topSearch space_between">
			<el-form inline class="el-form">
				<el-form-item>
					<el-select v-model="queryApi.mediaCompany" filterable clearable size="small" placeholder="请选择媒体公司"
					@change="companySelectChange">
						<el-option v-for="item in companyOptions" :key="item.value" :label="item.label" :value="item.label">
						</el-option>
					</el-select>
				</el-form-item>
				<!-- <el-form-item>
					<el-select v-model="queryApi.platformId" clearable size="small" @change="networkOptionsChange" placeholder="请选择广告网络">
						<el-option v-for="item in networkOptions" :key="item.platformId" :label="item.label" :value="item.platformId">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-select v-model="queryApi.platformNetworkId" clearable size="small"
					placeholder="请选择账号名称">
						<el-option v-for="item in accountOptions" :key="item.value" :label="item.label" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item> -->
				<el-form-item>
					<el-select v-model="queryApi.os" filterable clearable size="small" placeholder="请选择操作系统">
						<el-option v-for="item in osOptions" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
						<el-select v-model="appSelectForm" clearable @change="appSeleteChange" size="small" value-key="value"
							popper-class="appNameIdOptions" :popper-append-to-body="false" filterable placeholder="请选择应用"
							:remote-method="appRemoteMethod" :loading="appRemoteLoading" remote @clear="getMediaAppOption()">
							<el-option v-for="item in mediaAppOptions" :key="item.value"
								:value="item" :label="`应用：${item.label} | ${item.value}`">
								<div class="selectTemp2">
									<div class="selectAppName">{{item.label}}</div>
									<div class=""></div>
									<div class="selectAppId flex_start">
										<div>{{item.value}}</div>
										<img @click.stop="copyName(item.value)" src="../../assets/icon/copy.png" alt="" />
									</div>
								</div>
							</el-option>
						</el-select>
				</el-form-item>
				<el-form-item>
					<el-select v-model="queryApi.type" filterable clearable size="small" placeholder="请选择广告类型">
						<el-option v-for="item in adTypeOptions" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-select v-model="adsSelectFormMediaChannel" clearable @change="mediaAdsSeleteChange" size="small"
					value-key="value" popper-class="appNameIdOptions" :popper-append-to-body="false" filterable
					@clear="getMediaAdsOption(2)" :remote-method="mediaAdsRemoteMethod" :loading="adsRemoteLoading" remote
					placeholder="请选择聚合广告位" style="width: 280px;">
							<el-option v-for="(item,index) in mediaAdsOptions" :key="index" :label="`${item.label} | ${item.value}`"
								:value="item">
								<div class="selectTemp2">
									<div class="selectAppName">{{item.label}}</div>
									<div class=""></div>
									<div class="selectAppId flex_start">
										<div>{{item.value}}</div>
										<img @click.stop="copyName(item.value)" src="../../assets/icon/copy.png" alt="" />
									</div>
								</div>
							</el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-select v-model="queryApi.appProperty" clearable size="small" placeholder="请选择应用属性">
						<el-option v-for="item in appPropertyOptions" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<div class="menu-right flex_start">
				<el-button @click="searchReset" size="small" style="margin-right: 10px;margin-bottom: 6px;">重置</el-button>
				<div></div>
				<el-button type="primary" @click="apiQuery" size="small" style="height: 34px;"> 查询</el-button>
			</div>
		</div>
		<div class="card chart-card">
			<div class="chartTitRow">
				<div class="chartTitle">数据图表</div>
				<el-date-picker v-model="datePicker" value-format="yyyy-MM-dd" type="dates"
					placeholder="选择日期（最多三天）" size="small" :clearable="false"
					:picker-options="datePickerOptions" @change="handleDateChange"
					style="margin-left: auto;width: 360px;">
				</el-date-picker>
				<div class="splitTimePicker">时段</div>
				<el-time-picker
					:clearable="false"
					size="small"
				  is-range
				  v-model="dateTimeStartPicker"
					value-format="HH:mm:ss"
					format="HH:mm:ss"
				  range-separator="至"
				  start-placeholder="开始时段"
				  end-placeholder="结束时段"
				  placeholder="选择时间范围" style="width: 260px;">
				</el-time-picker>
				<!-- <div class="splitTimePicker">结束时段</div>
				<el-time-picker
					:clearable="false"
					size="small"
				  is-range
				  v-model="dateTimeEndPicker"
					value-format="HH:mm:ss"
					format="HH:mm:ss"
				  range-separator="至"
				  start-placeholder="开始时段"
				  end-placeholder="结束时段"
				  placeholder="选择时间范围" style="width: 260px;">
				</el-time-picker> -->
				<el-select v-model="chartQueryData.chartColumnChecked" size="small" style="margin-left: 15px;" @change="fetchChartData">
					<el-option v-for="item in chartColumnOptions" :key="item.value" :label="item.label" :value="item.value">
					</el-option>
				</el-select>
			</div>
			<div ref="timeShareChart" class="chart-box"></div>
		</div>
		<div class="card-table">
			<div class="menu-right-table">
				<div class="tHeadleftTips">查看维度</div>
				<el-checkbox :indeterminate="isDimensionIndeterminate" v-model="dimensionCheckAll" @change="handleCheckAllChangeDim"
					style="margin-right: 30px;">全选</el-checkbox>
					<el-checkbox-group v-model="tHeaderQueryChecked" class="tHeadFixedCheckList">
						<el-checkbox v-for="(item,index) in tHeaderQueryData" :label="item.valueNum" size="mini"
							:checked="item.checked" :key="index" :name="item.value" class="check-box-fixed"
							@change="checkBoxQueryChange($event,item,index)">{{item.label}}
						</el-checkbox>
					</el-checkbox-group>
				<el-button type="primary" size="small" style="margin-right: 10px;margin-left: auto;" @click="exportToExcelFromDOM">导出</el-button>
				<el-popover trigger="click" width="500">
					<div class="table-header-config">
						<div class="table-header-config-toolbar">
							<el-checkbox
								v-model="headerSelectAll"
								:indeterminate="headerIndeterminate"
							>全选</el-checkbox>
						</div>
						<div class="table-header-config-item" v-for="item in tHeadHeaderConfigList" :key="item.prop">
							<el-checkbox v-model="item.checked" @change="handleHeaderChange">{{ item.label }}</el-checkbox>
						</div>
					</div>
					<template slot="reference">
						<el-button type="primary" size="small">表头配置</el-button>
					</template>
				</el-popover>
			</div>
			<el-table :max-height="560" :data="tableData" class="el_table"
				:header-cell-style="{color:'#666666',background:'#F7F8F9'}"
				ref="multipleTable" @sort-change="sortChangeFun" :header-cell-class-name="handleHeadAddClass">
				<el-table-column prop="companyName" label="媒体公司" min-width="90"
					v-if="tHeaderQueryChecked.indexOf(2) !== -1"></el-table-column>
				<el-table-column prop="os" label="操作系统" min-width="90" v-if="tHeaderQueryChecked.indexOf(3) !== -1"></el-table-column>
				<el-table-column prop="mediaAppId" label="应用" min-width="160" v-if="tHeaderQueryChecked.indexOf(4) !== -1">
					<template slot-scope="scope">
						<div v-if="scope.row.mediaAppId">
							<div>{{scope.row.mediaAppName}}</div>
							<div style="color: #4F7AFD;">{{scope.row.mediaAppId}}</div>
						</div>
						<div v-else>-</div>
					</template>
				</el-table-column>
				<el-table-column prop="type" label="广告位类型" min-width="130" v-if="tHeaderQueryChecked.indexOf(5) !== -1">
					<template slot-scope="scope">
						<span>{{getAdTypeRenderText(scope.row)}}</span>
					</template>
				</el-table-column>
				<el-table-column label="聚合广告位" min-width="180" v-if="tHeaderQueryChecked.indexOf(6) !== -1">
					<template slot-scope="scope">
						<div v-if="scope.row.adsId">
							<div>{{scope.row.adsName}}</div>
							<div style="color: #4F7AFD;">{{scope.row.adsId}}</div>
						</div>
						<div v-else>-</div>
					</template>
				</el-table-column>
				<el-table-column prop="" label="时间" min-width="180" align="center">
					<template slot-scope="scope">
						<div v-if="Array.isArray(scope.row.timeRange)&&scope.row.timeRange.length>0">
							<div
								v-for="(t, idx) in scope.row.timeRange"
								:key="idx"
								class="updownText"
								:class="{ mgb0: idx === scope.row.timeRange.length - 1 }"
							>{{ t }}</div>
						</div>
						<div v-else-if="!Array.isArray(scope.row.timeRange) && scope.row.timeRange">{{ scope.row.timeRange }}</div>
						<div v-else>-</div>
					</template>
				</el-table-column>
				<template v-for="columnObj in visibleTHeadList">
					<el-table-column :prop="columnObj.prop" :label="columnObj.label" align="center"
						:min-width="columnObj.minWidth"
						:fixed="columnObj.fixed" :sortable="columnObj.sortable?'custom':false" :key="columnObj.prop">
						<template v-slot="scope">
							<slot :name="columnObj.prop" :scope="scope">
								<div v-if="Array.isArray(scope.row[columnObj.prop]) && scope.row[columnObj.prop].length">
									<div
										v-for="(cellVal, idx) in scope.row[columnObj.prop]"
										:key="idx"
										class="updownText"
										:class="{ mgb0: idx === scope.row[columnObj.prop].length - 1 }"
									>{{ formatCellForMetric(cellVal, columnObj.label) }}</div>
								</div>
								<div v-else-if="hasScalarMetricCell(scope.row, columnObj.prop)">
									{{ formatCellForMetric(scope.row[columnObj.prop], columnObj.label) }}
								</div>
								<div v-else>-</div>
							</slot>
						</template>
					</el-table-column>
				</template>
			</el-table>
			<div class="paging">
				<el-pagination @size-change="handleSizeChange" background @current-change="handleCurrentChange"
					:current-page="currentPage" :page-sizes="[10, 20, 30, 500]" :page-size="pageSize"
					layout="total, sizes, prev, pager, next, jumper" :total="total">
				</el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	import * as echarts from "echarts";
	import * as XLSX from 'xlsx';

	/**
	 * 折线图每条序列对应的主题色（最多与服务端 7 日 series 下标对齐）。
	 * 前两种颜色历史上对应「旧版两条线」对比图，其余用于多日折线扩展。
	 */
	const CHART_LINE_COLORS = [
		"#20B2AA",
		"#007FFF",
		"#FF6B6B",
		"#A855F7",
		"#F59E0B",
		"#10B981",
		"#6366F1",
	]

	export default {
		data() {
			return {
				queryApi: {
					isMedia: true,
					mediaCompany: '',
					mediaAppId: '',
					mediaAdId: '',
					os: '',
					type: '',
					pageNum: 1,
					pageSize: 10,
					appProperty: ''
				},
				isDimensionIndeterminate: false,
				dimensionCheckAll: true,
				datePicker: [],
				// 禁止未来日期，并在选满三天后只允许取消已选日期
				datePickerOptions: {},
				companyOptions: [], //公司下拉选择列表
				osOptions: this.$api.osOptions, // OS下拉选择列表
				mediaAppOptions: [], // 媒体APP下拉选择列表
				appSelectForm: {}, // 媒体APP下拉选中值
				appRemoteLoading: false,
				adTypeOptions: this.$api.adsTypeOptions, // 广告类型
				appPropertyOptions: this.$api.appPropertyOptions, // 应用属性下拉选择列表

				adsSelectFormMediaChannel: {}, //聚合广告位下拉选中数据
				mediaAdsOptions: [], //聚合广告位下拉列表
				adsRemoteLoading: false,
				dateTimeStartPicker: [],

				chartQueryData: {
					chartColumnChecked: 'estimateProfit',
				},

				tableData: [],
				currentPage: 1,
				pageSize: 10,
				total: 0,
				// 表格排序数据
				sortField: {},
				// 表格列 prop -> 服务端 orderField 的映射（需要自定义时在这里配置）
				// 例如：{ firstRequestNum: 'firstRequestCount' }
				// 注意：只有“请求数/收益”需要排序，这里给出 prop -> 后端 orderField 映射
				// 与 channelData 一致：默认按列 prop 作为 orderField，若有差异在此映射
				sortPropToOrderField: {},
				orderBys: [],

				tHeadCheckedList: [],
				// 与 mediaData.vue tHeadAllList 各分组 list（二级）顺序、字段一致，按分组依次拼接为一维
				tHeadNormalCheckedList: [
					{
						prop: 'channelEstimateProfit',
						label: '总收益(¥)',
						checked: false,
						sortable: false,
						minWidth: '120',
					},
					{
						prop: 'estimateProfit',
						label: '媒体收益(¥)',
						checked: true,
						sortable: false,
						minWidth: '120',
					},
					{
						prop: 'divideEstimateProfit',
						label: '分成收益(¥)',
						checked: false,
						sortable: false,
						minWidth: '120',
					},
					{
						prop: 'reqNum',
						label: '流量请求量',
						checked: false,
						sortable: false,
						minWidth: '120',
					},
					{
						prop: 'succNum',
						label: '流量返回量',
						checked: false,
						sortable: false,
						minWidth: '120',
					},
					{
						prop: 'succReqRate',
						label: '流量填充率',
						checked: false,
						sortable: false,
						minWidth: '120',
					},
					{
						prop: 'showNum',
						label: '流量展示量',
						checked: true,
						sortable: false,
						minWidth: '120',
					},
					{
						prop: 'succShowRate',
						label: '流量展示率',
						checked: false,
						sortable: false,
						minWidth: '120',
					},
					{
						prop: 'clickNum',
						label: '流量点击量(未去重)',
						checked: false,
						sortable: false,
						minWidth: '150',
					},
					{
						prop: 'uniqueClickNum',
						label: '流量点击量(去重)',
						checked: false,
						sortable: false,
						minWidth: '140',
					},
					{
						prop: 'deductClickNum',
						label: '流量点击量(扣量后)',
						checked: true,
						sortable: false,
						minWidth: '150',
					},
					{
						prop: 'clickRate',
						label: '流量点击率(未去重)',
						checked: false,
						sortable: false,
						minWidth: '150',
					},
					{
						prop: 'uniqueClickRate',
						label: '流量点击率(去重)',
						checked: false,
						sortable: false,
						minWidth: '150',
					},
					{
						prop: 'deductClickRate',
						label: '流量点击率(扣量后)',
						checked: false,
						sortable: false,
						minWidth: '150',
					},
					{
						prop: 'channelEcpm',
						label: '总收益eCPM(¥)',
						checked: false,
						sortable: false,
						minWidth: '140',
					},
					{
						prop: 'ecpm',
						label: '媒体收益eCPM(¥)',
						checked: true,
						sortable: false,
						minWidth: '140',
					},
					// {
					// 	prop: 'pv',
					// 	label: 'PV',
					// 	checked: false,
					// 	sortable: false,
					// 	minWidth: '120',
					// },
					// {
					// 	prop: 'uv',
					// 	label: 'UV',
					// 	checked: false,
					// 	sortable: false,
					// 	minWidth: '120',
					// },
					// {
					// 	prop: 'deu',
					// 	label: 'DEU',
					// 	checked: false,
					// 	sortable: false,
					// 	minWidth: '120',
					// },
					{
						prop: 'fillRate',
						label: '竞得率',
						checked: false,
						sortable: false,
						minWidth: '120',
					},
					{
						prop: 'avgShowNum',
						label: '均展量',
						checked: false,
						sortable: false,
						minWidth: '120',
					},
					{
						prop: 'finishNum',
						label: '完播量',
						checked: false,
						sortable: false,
						minWidth: '120',
					},
					{
						prop: 'finishRate',
						label: '完播率',
						checked: false,
						sortable: false,
						minWidth: '120',
					},
					// {
					// 	prop: 'apiIncome',
					// 	label: 'API收益',
					// 	checked: true,
					// 	sortable: false,
					// 	minWidth: '140',
					// },
					// {
					// 	prop: 'apiReqNum',
					// 	label: 'API请求量',
					// 	checked: true,
					// 	sortable: false,
					// 	minWidth: '140',
					// },
					// {
					// 	prop: 'apiSuccNum',
					// 	label: 'API返回量',
					// 	checked: false,
					// 	sortable: false,
					// 	minWidth: '140',
					// },
					// {
					// 	prop: 'apiSuccRate',
					// 	label: 'API填充率',
					// 	checked: false,
					// 	sortable: false,
					// 	minWidth: '140',
					// },
					// {
					// 	prop: 'apiShowNum',
					// 	label: 'API展示量',
					// 	checked: true,
					// 	sortable: false,
					// 	minWidth: '120',
					// },
					// {
					// 	prop: 'apiUniqueClickNum',
					// 	label: 'API点击量(去重)',
					// 	checked: false,
					// 	sortable: false,
					// 	minWidth: '140',
					// },
					// {
					// 	prop: 'apiDeductClickNum',
					// 	label: 'API点击量(扣量后)',
					// 	checked: true,
					// 	sortable: false,
					// 	minWidth: '140',
					// },
					// {
					// 	prop: 'apiUniqueClickRate',
					// 	label: 'API点击率(去重)',
					// 	checked: false,
					// 	sortable: false,
					// 	minWidth: '150',
					// },
					// {
					// 	prop: 'apiDeductClickRate',
					// 	label: 'API点击率(扣量后)',
					// 	checked: false,
					// 	sortable: false,
					// 	minWidth: '150',
					// },
					// {
					// 	prop: 'apiEcpm',
					// 	label: 'API eCPM(￥)',
					// 	checked: true,
					// 	sortable: false,
					// 	minWidth: '120',
					// },
					// {
					// 	prop: 'reqGapRate',
					// 	label: '请求GAP率',
					// 	checked: false,
					// 	sortable: false,
					// 	minWidth: '120',
					// 	temp: true,
					// },
					// {
					// 	prop: 'reqSuccGapRate',
					// 	label: '返回GAP率',
					// 	checked: false,
					// 	sortable: false,
					// 	minWidth: '120',
					// 	temp: true,
					// },
					// {
					// 	prop: 'showGapRate',
					// 	label: '展示GAP率',
					// 	checked: false,
					// 	sortable: false,
					// 	minWidth: '120',
					// 	temp: true,
					// },
					// {
					// 	prop: 'clickGapRate',
					// 	label: '点击GAP率',
					// 	checked: false,
					// 	sortable: false,
					// 	minWidth: '120',
					// 	temp: true,
					// },
					// {
					// 	prop: 'ecpmGapRate',
					// 	label: 'eCPM GAP率',
					// 	checked: false,
					// 	sortable: false,
					// 	minWidth: '120',
					// 	temp: true,
					// },
					// {
					// 	prop: 'incomeGapRate',
					// 	label: '收益GAP率',
					// 	checked: true,
					// 	sortable: false,
					// 	minWidth: '120',
					// 	temp: true,
					// },
				],
				tHeadStorageKey: 'sdk-timeShareReport-mediaDimension-tHead',
				// 表头列结构（prop 增删、合并规则）变更时递增，会触发与本地缓存重新对齐
				tHeadSchemaVersion: 4,

				tHeaderQueryChecked: [2, 3, 4, 5, 6],
				tHeaderQueryData: [
					{value: 'companyName', valueNum: 2, label: "媒体公司", checked: false},
					{value: 'os', valueNum: 3, label: "操作系统", checked: false},
					{value: 'mediaAppId', valueNum: 4, label: "应用", checked: false},
					{value: 'type', valueNum: 5, label: "广告位类型", checked: false},
					{value: 'mediaAdId', valueNum: 6, label: "聚合广告位", checked: false},
				],
			}
		},
		computed: {
			/**
			 * 表头勾选弹窗用的「全量列配置」列表。
			 * 与 mediaData.vue 中 tHeadAllList 的二级列字段保持一致，便于两处报表列对齐。
			 */
			tHeadHeaderConfigList() {
				return this.tHeadCheckedList
			},
			/**
			 * 当前表格实际渲染的列：从已配置列中筛掉 checked === false 的项。
			 * 用于 el-table-column 的 v-for，与表头勾选状态联动。
			 */
			visibleTHeadList() {
				return this.tHeadCheckedList.filter((col) => col.checked !== false)
			},
			/**
			 * 表头全选 Checkbox 的半选态：至少选一列、但未全选时为 true。
			 */
			headerIndeterminate() {
				const mains = this.tHeadCheckedList
				if (!mains.length) return false
				const n = mains.filter((i) => i.checked).length
				return n > 0 && n < mains.length
			},
			/**
			 * 表头全选 Checkbox 的双向绑定。
			 * get：全部列为 checked 时为 true；set：统一勾选/取消并持久化、触发表格 doLayout。
			 */
			headerSelectAll: {
				get() {
					const mains = this.tHeadCheckedList
					if (!mains.length) return false
					return mains.every((i) => i.checked)
				},
				set(val) {
					this.tHeadCheckedList.forEach((m) => {
						m.checked = val
					})
					this.handleHeaderChange()
				},
			},
			/**
			 * 「数据图表」下拉选项：value 为接口 metric / 列 prop，label 为列中文名。
			 * 与 tHeadNormalCheckedList 同源，保证图表指标与表格可展示指标一致。
			 */
			chartColumnOptions() {
				return this.tHeadNormalCheckedList.map((col) => ({ value: col.prop, label: col.label }))
			},
		},
		/** 配置多选日期：最多三天，选中的日期可再次点击取消。 */
		created() {
			const vm = this
			this.datePickerOptions = {
				disabledDate(time) {
					const todayStart = new Date()
					todayStart.setHours(0, 0, 0, 0)
					if (time.getTime() > todayStart.getTime()) return true
					const pad = (n) => String(n).padStart(2, '0')
					const date = `${time.getFullYear()}-${pad(time.getMonth() + 1)}-${pad(time.getDate())}`
					return vm.datePicker.length >= 3 && !vm.datePicker.includes(date)
				},
			}
		},
		/**
		 * 首屏初始化：恢复表头勾选缓存、拉取下拉选项、默认日期与列表数据；
		 * 下一帧再拉图表，保证日期 ref 已就绪，避免图表接口参数不完整。
		 */
		mounted(){
			this.initTHeadCheckedList()
			// this.chartQueryData['chartColumnChecked'] = this.chartColumnOptions[0].value
			this.getCompanyOption();
			this.getMediaAdsOption(2, null);
			this.dateInit()
			this.getMediaAppOption();
			this.getTableData()
			this.$nextTick(() => {
				this.fetchChartData()
			})
		},
		methods: {
			/** 日期面板确认后按时间升序排列，展示和请求参数使用同一顺序。 */
			handleDateChange(dates) {
				if (Array.isArray(dates)) this.datePicker = dates.slice().sort()
			},
			// 拼接广告位类型与渲染类型展示文案
			getAdTypeRenderText(row) {
				if(!row.type){
					return '-'
				}
				if(row.isSelfRender === 1||row.isSelfRender === '1'){
					return `${row.type}（自渲染）`
				}
				if(row.isSelfRender === 0||row.isSelfRender === '0'){
					return `${row.type}（模版渲染）`
				}
				return row.type
			},
			/**
			 * 初始化日期与时段默认值（仅前端展示，不请求接口）。
			 * - datePicker：默认昨天和今天（yyyy-MM-dd）；可独立选择最多三天
			 * - dateTimeStartPicker：全天 00:00:00 ～ 23:59:59（与时段选择器绑定）
			 * - dateTimeEndPicker：同上副本（模板中若存在结束时段选择器时使用）
			 */
			dateInit() {
				this.datePicker = []
				const pad = (n) => String(n).padStart(2, '0')
				const formatYmd = (d) =>
					`${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
				const now = new Date()
				const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate())
				const yesterdayStart = new Date(todayStart)
				yesterdayStart.setDate(yesterdayStart.getDate() - 1)
				this.datePicker.push(formatYmd(yesterdayStart))
				this.datePicker.push(formatYmd(todayStart))
				const defaultDayRange = ['00:00:00', '23:59:59']
				this.dateTimeStartPicker = defaultDayRange
				this.dateTimeEndPicker = defaultDayRange.slice()
			},
			/**
			 * 表格上方「维度」分组勾选：全选 / 全不选。
			 * 勾选为真时把 tHeaderQueryData 中各项的 valueNum 全部写入 tHeaderQueryChecked；
			 * 清空半选态，页码回到第一页并重新请求列表。
			 * @param {boolean} val 全选框的选中状态
			 */
			handleCheckAllChangeDim(val){
				this.tHeaderQueryChecked = []
				if(val){
					this.tHeaderQueryData.forEach((item) => {
						this.tHeaderQueryChecked.push(item.valueNum)
					})
				}
				this.isDimensionIndeterminate = false;
				this.currentPage = 1
				this.getTableData();
			},
			/**
			 * 单个维度项勾选变化：同步该项 checked、全选/半选状态、tHeaderQueryChecked 由 el-checkbox-group 维护。
			 * 页码重置为 1 后重新拉取表格（groupByIdList 随勾选变化）。
			 * @param {boolean} e 当前项是否勾选
			 * @param {object} item 维度配置项（未直接使用，保留与模板事件签名一致）
			 * @param {number} index 在 tHeaderQueryData 中的下标
			 */
			checkBoxQueryChange(e, item, index) {
				this.tHeaderQueryData[index].checked = e
				this.dimensionCheckAll = this.tHeaderQueryChecked.length === this.tHeaderQueryData.length
				this.isDimensionIndeterminate = this.tHeaderQueryChecked.length > 0 &&  this.tHeaderQueryChecked.length < this.tHeaderQueryData.length
				this.currentPage = 1
				this.getTableData();
			},
			/**
			 * 聚合广告位选择变更：将选中项整对象存入 adsSelectFormMediaChannel，供查询时传 adsId。
			 * @param {object} e el-option 的 value（含 label、value 等）
			 */
			mediaAdsSeleteChange(e) {
				if (e && e.value) {
					this.adsSelectFormMediaChannel = e
				}
			},
			/**
			 * 聚合广告位远程搜索：300ms 防抖后请求 getMediaAdsOption(2, query)。
			 * 注意：当前 clearTimeout() 无定时器 id，实际防抖仅依赖 setTimeout 间隔。
			 * @param {string} query 用户输入的关键字
			 */
			mediaAdsRemoteMethod(query) {
				clearTimeout();
				setTimeout(() => {
					this.adsRemoteLoading = true
					this.getMediaAdsOption(2, query)
				}, 300)
			},
			/** 请求媒体公司下拉数据，写入 companyOptions，供筛选项「媒体公司」使用。 */
			async getCompanyOption() {
				let res = await this.$http.get(this.$api.common.companyOption);
				this.companyOptions = res.data
			},
			/**
			 * 媒体公司变更后清空已缓存的 APP 列表并重新拉取，避免跨公司仍显示旧应用选项。
			 */
			companySelectChange(){
				this.mediaAppOptions = []
				this.getMediaAppOption();
			},
			/**
			 * 按当前选中的媒体公司 + 可选 appId 关键字请求媒体应用列表。
			 * @param {string|null} query 远程搜索关键字，为 null 时拉全量（受公司筛选约束）
			 */
			async getMediaAppOption(query = null) {
				let data = {
					mediaCompany: this.queryApi.mediaCompany,
					appId: query,
				}
				let res = await this.$http.get(this.$api.common.mediaAppOption,data);
				this.appRemoteLoading = false
				this.mediaAppOptions = res.data
			},
			/**
			 * 媒体应用下拉选中：保存整对象 appSelectForm，查询列表时取 .value 作为 appId。
			 * @param {object} e 选中项对象
			 */
			appSeleteChange(e) {
				this.appSelectForm = e
			},
			/**
			 * 媒体应用远程搜索：300ms 后带 query 调用 getMediaAppOption。
			 * @param {string} query 用户输入
			 */
			appRemoteMethod(query){
				clearTimeout();
				setTimeout(()=>{
					this.appRemoteLoading = true
					this.getMediaAppOption(query)
				},300)
			},
			/**
			 * 请求聚合广告位下拉列表，结果写入 mediaAdsOptions。
			 * @param {number} type 接口类型参数（与公共接口约定一致，此处固定传 2）
			 * @param {string|null} query 按名称模糊搜索，null 表示不限定关键字
			 */
			async getMediaAdsOption(type, query = null) {
				let data = {
					adsName: query
				}
				let res = await this.$http.get(this.$api.common.mediaAdsOption, data);
				this.adsRemoteLoading = false
				this.mediaAdsOptions = res.data
			},
			/**
			 * 按广告网络平台 ID 拉取账号名称下拉（模板中相关筛选项若启用时使用）。
			 * @param {string|number} platformId 平台主键
			 */
			async getAccountOptions(platformId){
				let data = {platformId: platformId}
				let res = await this.$http.get(this.$api.mediaAd.networkAccountOption,data);
				this.accountOptions = res.data
			},
			/**
			 * 复制文本到剪贴板：优先 Clipboard API，失败（非 HTTPS 等环境）则走 fallbackCopy。
			 * @param {string} txt 一般为应用 ID 或名称
			 */
			async copyName(txt) {
				try {
					// 使用现代异步 API
					await navigator.clipboard.writeText(txt)
					this.$message.success('复制成功');
				} catch (err) {
					// 某些环境（比如 HTTP 或非安全上下文）不支持 navigator.clipboard
					// 这里可做回退方案：
					this.fallbackCopy(txt)
				}
			},
			/**
			 * 剪贴板回退：临时创建 input、select + execCommand('copy')，兼容旧浏览器或非安全上下文。
			 * @param {string} text 待复制内容
			 */
			fallbackCopy(text) {
				const input = document.createElement('input')
				input.value = text
				document.body.appendChild(input)
				input.select()
				document.execCommand('copy')
				document.body.removeChild(input)
				this.$message.success('复制成功');
			},
			/**
			 * 表格单元格通用占位：null / undefined / '' 显示为「-」，其余原样返回。
			 * @param {*} val 单元格原始值
			 */
			formatCell(val) {
				if (val === null || val === undefined || val === '') return '-'
				return val
			},
			/**
			 * 根据列中文名判断是否视为「率」类指标：去掉首尾空格后最后一个字符为「率」。
			 * 用于表格展示与图表 Y 轴、tooltip 是否追加百分号。
			 * @param {string|null|undefined} label 列 label
			 */
			labelEndsWithRate(label) {
				if (label == null || label === '') return false
				const s = String(label).trim()
				return s.length > 0 && s[s.length - 1] === '率'
			},
			/**
			 * 按列类型格式化单元格：先走 formatCell；若为率类且值非「-」，则保证带 % 后缀。
			 * @param {*} val 单元格值
			 * @param {string} label 列中文名
			 */
			formatCellForMetric(val, label) {
				const base = this.formatCell(val)
				if (base === '-') return base
				if (!this.labelEndsWithRate(label)) return base
				const s = String(base)
				return s.endsWith('%') ? s : `${s}%`
			},
			/**
			 * 初始化表头勾选列表：优先读本地缓存（含 schema 版本号），无或解析失败则用默认 tHeadNormalCheckedList。
			 * - 与旧 key sdk-mediaDataTHead 兼容迁移
			 * - schema 变更时更新版本号并重新持久化，避免列结构升级后缓存错乱
			 * - 每项缺省 checked 时默认为 true
			 */
			initTHeadCheckedList() {
				const verKey = `${this.tHeadStorageKey}:schemaVer`
				const storedVer = localStorage.getItem(verKey)
				const schemaMismatch = storedVer !== String(this.tHeadSchemaVersion)
				let raw = localStorage.getItem(this.tHeadStorageKey)
				if (!raw) raw = localStorage.getItem('sdk-mediaDataTHead')
				let parsed = []
				if (raw) {
					try {
						parsed = JSON.parse(raw)
					} catch (e) {
						parsed = []
					}
				}
				if (!Array.isArray(parsed)) parsed = []
				let list
				if (!parsed.length) {
					list = JSON.parse(JSON.stringify(this.tHeadNormalCheckedList))
				} else {
					list = this.mergeTHeadWithDefault(parsed)
				}
				list.forEach((item) => {
					if (item.checked === undefined) item.checked = true
				})
				this.tHeadCheckedList = list
				if (schemaMismatch) {
					localStorage.setItem(verKey, String(this.tHeadSchemaVersion))
				}
				this.persistTHeadCheckedList()
			},
			/**
			 * 将本地缓存的表头行与当前代码中的列定义合并。
			 * 列的 prop、label、minWidth、sortable 等一律以 tHeadNormalCheckedList 为准；
			 * 仅恢复用户之前勾选过的 checked，避免旧版本缓存覆盖新列配置。
			 * @param {object[]} saved localStorage 解析后的数组
			 * @returns {object[]} 合并后的表头配置列表
			 */
			mergeTHeadWithDefault(saved) {
				const byProp = {}
				saved.forEach((row) => {
					if (row && row.prop) byProp[row.prop] = row
				})
				return this.tHeadNormalCheckedList.map((def) => {
					const old = byProp[def.prop]
					const baseChecked = def.checked !== undefined ? def.checked : true
					const checked =
						old && typeof old.checked === 'boolean' ? old.checked : baseChecked
					return {
						...def,
						checked,
					}
				})
			},
			/** 将当前 tHeadCheckedList 序列化写入 localStorage，供下次进入页面恢复。 */
			persistTHeadCheckedList() {
				localStorage.setItem(this.tHeadStorageKey, JSON.stringify(this.tHeadCheckedList))
			},
			/**
			 * 表头勾选变更后的统一收尾：持久化 + 下一帧对表格 doLayout，防止列显示/隐藏后宽度错乱。
			 */
			handleHeaderChange() {
				this.persistTHeadCheckedList()
				this.$nextTick(() => {
					this.$refs.multipleTable && this.$refs.multipleTable.doLayout()
				})
			},
			/**
			 * 向请求体追加「单日 + 时段」形式的起止时间（若存在 dateStartPicker / dateEndPicker 计算或数据字段）。
			 * 用于与列表/导出不同的时间拼装形态；缺省时段取自 dateTimeStartPicker 两段或 00:00:00 / 23:59:59。
			 * @param {object} data 即将提交的请求体（会被就地修改）
			 */
			appendTimeRangeToPayload(data) {
				const padTime = (arr, idx, fallback) => {
					if (arr && arr.length > idx && arr[idx]) return arr[idx]
					return fallback
				}
				if (this.dateStartPicker) {
					const t0 = padTime(this.dateTimeStartPicker, 0, '00:00:00')
					const t1 = padTime(this.dateTimeStartPicker, 1, '23:59:59')
					data.startTime = `${this.dateStartPicker} ${t0}`
					data.endTime = `${this.dateStartPicker} ${t1}`
				}
				if (this.dateEndPicker) {
					const t0 = padTime(this.dateTimeStartPicker, 0, '00:00:00')
					const t1 = padTime(this.dateTimeStartPicker, 1, '23:59:59')
					data.compareStartTime = `${this.dateEndPicker} ${t0}`
					data.compareEndTime = `${this.dateEndPicker} ${t1}`
				}
			},
			/**
			 * 用户点击「查询」：页码置 1，刷新表格与图表（二者时间、筛选条件一致）。
			 */
			apiQuery() {
				this.currentPage = 1
				this.queryApi.pageNum = 1
				this.getTableData()
				this.fetchChartData()
			},
			/**
			 * 组装「分时报表对比」列表/图表/导出共用的请求体。
			 * - timeRanges：每个已选日期与 dateTimeStartPicker 拼成「日期 开始-结束」数组
			 * - 先深拷贝 queryApi，再合并排序 adOrderByReqs，最后 Object.assign 覆盖 overrides（如 metric、page）
			 * @param {object} [overrides] 额外字段，例如 { metric, page, pageSize }
			 * @returns {object} 可直接 POST 的 data
			 */
			buildReportQueryBody(overrides) {
				const data = JSON.parse(JSON.stringify(this.queryApi))
				data.timeRanges = this.datePicker.map((date) =>
					`${date} ${this.dateTimeStartPicker[0]}-${this.dateTimeStartPicker[1]}`
				)
				if (this.orderBys && this.orderBys.length) {
					data.adOrderByReqs = this.orderBys
				}
				return Object.assign(data, overrides || {})
			},
			/**
			 * 列表 / 图表 / 导出共用：把顶部表单里不在 queryApi 上的条件写入请求体（与 getTableData 一致）。
			 * @param {object} data buildReportQueryBody 返回的对象（就地修改）
			 */
			appendTopFilterToReportBody(data) {
				if (this.appSelectForm && this.appSelectForm.value) {
					data.appId = this.appSelectForm.value
				}
				if (this.adsSelectFormMediaChannel && this.adsSelectFormMediaChannel.value) {
					data.adsId = this.adsSelectFormMediaChannel.value
				}
				if (this.tHeaderQueryChecked && this.tHeaderQueryChecked.length > 0) {
					data.groupByIdList = this.tHeaderQueryChecked
				}
			},
			/**
			 * 判断是否已选至少一天及完整时段，未就绪时不请求列表与图表。
			 * @returns {boolean}
			 */
			reportQueryTimeReady() {
				return (
					this.datePicker &&
					this.datePicker.length >= 1 &&
					this.dateTimeStartPicker &&
					this.dateTimeStartPicker.length >= 2
				)
			},
			/**
			 * 生成导出文件名时间前缀：yyyyMMdd_HHmm，与接口第三个参数拼接为完整下载文件名。
			 * @returns {string}
			 */
			getExportFileNamePrefix() {
				const d = new Date()
				const pad = (n) => String(n).padStart(2, '0')
				return `${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}_${pad(d.getHours())}:${pad(
					d.getMinutes()
				)}`
			},
			/**
			 * 导出当前筛选条件下的分时报表：二次确认后，pageSize 置极大值拉全量，文件名带时间前缀。
			 * 取消确认时不发起请求。
			 */
			timeDataReportExport() {
				if (!this.reportQueryTimeReady()) {
					this.$message.warning('请先选择日期与时段')
					return
				}
				this.$confirm('此操作将导出当前查询条件下的数据，是否继续？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
				})
					.then(async () => {
						const data = this.buildReportQueryBody({ page: 1, pageSize: 999999 })
						this.appendTopFilterToReportBody(data)
						const prefix = this.getExportFileNamePrefix()
						const res = await this.$http.post(this.$api.dataManage.timeDataReportExport,data,1);
						this.$http.downloads(res, `${prefix}媒体分时报表对比.xlsx`)
					})
					.catch(() => {})
			},
			/**
			 * 根据接口返回的 columnTotals 构造表格首行「合计」行。
			 * 固定维度列 companyName/os/type 展示为合计或「-」，指标列按 tHeadNormalCheckedList 的 prop 从 columnTotals 取值。
			 * @param {object} root 接口 data 根对象，需含 columnTotals
			 * @returns {object} 带 isSummaryRow: true 的行数据
			 */
			buildTimeShareSummaryRow(root) {
				const c =
					root &&
					root.columnTotals &&
					typeof root.columnTotals === "object" &&
					!Array.isArray(root.columnTotals)
						? root.columnTotals
						: {}
				const cell = (v) => (v == null || v === "" ? "-" : v)
				const row = { isSummaryRow: true, companyName: "合计", os: "-", type: "-" }
				this.tHeadNormalCheckedList.forEach(({ prop }) => {
					row[prop] = cell(c[prop])
				})
				row.timeRange = c.timeRange
				return row
			},
			/**
			 * 判断某列在当前行是否为「标量」指标单元格：值非空且非数组（数组多用于对比两时段展示）。
			 * @param {object} row 表格行
			 * @param {string} prop 列 prop
			 * @returns {boolean}
			 */
			hasScalarMetricCell(row, prop) {
				const v = row[prop]
				if (v === null || v === undefined || v === "") return false
				return !Array.isArray(v)
			},
			/**
			 * 分页请求分时报表列表：依赖 reportQueryTimeReady。
			 * 成功后将 columnTotals 生成合计行插到列表首位，并更新 totalSeries；
			 * 附加 appId、adsId、groupByIdList 等筛选与维度分组参数。
			 */
			async getTableData() {
				if (!this.reportQueryTimeReady()) {
					return
				}
				let data = this.buildReportQueryBody();
				this.appendTopFilterToReportBody(data)
				let res = await this.$http.post(this.$api.dataManage.timeDataReportList,data);
				if (res.code == 200||res.code == 1) {
					const d = res.data || {}
					const list = [...(d.list || [])]
					if (list.length) list.unshift(this.buildTimeShareSummaryRow(d))
					this.tableData = list
					this.total = d.totalSeries
				}
			},
			/**
			 * 根据当前图表下拉 chartColumnChecked 在 chartColumnOptions 中解析中文指标名；
			 * 未匹配时返回「指标」，供 Y 轴 name 与 tooltip 标题使用。
			 */
			getChartMetricLabel() {
				const t = this.chartQueryData.chartColumnChecked
				const opt = this.chartColumnOptions.find((o) => o.value === t)
				return opt ? opt.label : '指标'
			},
			/**
			 * 构造「旧版两条线」对比模式下每条线的图例文案：日期 + 时段小时区间（如 2024-10-09 0~8）。
			 * periodIndex 对应 datePicker 中的已选日期；无法解析时退回时段序号。
			 * @param {0|1} periodIndex 0 表示区间第一天，1 表示第二天
			 */
			buildChartPeriodLabel(periodIndex) {
				if (!this.datePicker || !this.datePicker[periodIndex]) {
					return periodIndex === 0 ? '第一时段' : '第二时段'
				}
				const date = this.datePicker[periodIndex]
				const t = this.dateTimeStartPicker
				if (!t || t.length < 2) return date
				const p0 = String(t[0]).split(':')
				const p1 = String(t[1]).split(':')
				const h0 = parseInt(p0[0], 10)
				const h1 = parseInt(p1[0], 10)
				if (Number.isNaN(h0) || Number.isNaN(h1)) return date
				return `${date} ${h0}~${h1}`
			},
			/**
			 * 解析图表图例名称数组，长度与 series 条数一致。
			 * 优先级：1）embeddedNames 与 count 等长；2）依次尝试 d 上 seriesNames、legendNames、legend、dayLabels、names、dates；
			 * 缺项用「系列i」占位，保证 ECharts legend 与 series 一一对应。
			 * @param {object} d 图表接口 data
			 * @param {number} count 折线条数
			 * @param {string[]|null} embeddedNames 归一化阶段嵌入的名称数组（当前多为 null）
			 */
			resolveChartLegendNames(d, count, embeddedNames) {
				if (Array.isArray(embeddedNames) && embeddedNames.length === count) {
					return embeddedNames.map((n, i) => (n != null && n !== '' ? String(n) : `系列${i + 1}`))
				}
				const nameKeys = ['seriesNames', 'legendNames', 'legend', 'dayLabels', 'names', 'dates']
				for (let k = 0; k < nameKeys.length; k++) {
					const arr = d[nameKeys[k]]
					if (!Array.isArray(arr) || !arr.length) continue
					return Array.from({ length: count }, (_, i) => {
						const v = arr[i]
						return v != null && v !== '' ? String(v) : `系列${i + 1}`
					})
				}
				// 服务端未返回图例时，按已选日期标注对应的折线。
				if (count === this.datePicker.length) {
					return this.datePicker.map((_, i) => this.buildChartPeriodLabel(i))
				}
				return Array.from({ length: count }, (_, i) => `系列${i + 1}`)
			},
			/**
			 * 将接口返回的图表数据统一为「多折线二维数组」形态。
			 * - 新结构：d.series 为 number[][]，每行一天/一条线，与 hourTime 等长
			 * - 旧结构：d.first、d.second 两条一维数组，标记 legacyTwoLine 供图例强制用 buildChartPeriodLabel
			 * @param {object} d 图表接口 data
			 * @returns {{ list: number[][], legacyTwoLine: boolean, embeddedNames: null }}
			 */
			normalizeChartSeriesArrays(d) {
				if (!d || typeof d !== "object") return { list: [], legacyTwoLine: false, embeddedNames: null }
				const series = d.series
				if (
					Array.isArray(series) &&
					series.length > 0 &&
					series.every((row) => Array.isArray(row))
				) {
					return { list: series, legacyTwoLine: false, embeddedNames: null }
				}
				const first = Array.isArray(d.first) ? d.first : []
				const second = Array.isArray(d.second) ? d.second : []
				if (first.length || second.length) {
					return { list: [first, second], legacyTwoLine: true, embeddedNames: null }
				}
				return { list: [], legacyTwoLine: false, embeddedNames: null }
			},
			/**
			 * 渲染无数据占位图：重置实例后设置空 category 轴、无 series，保留 tooltip 样式以便用户仍能触发坐标轴提示（空数据）。
			 * 在查询条件不全、接口失败或未选指标时调用。
			 */
			renderEmptyChart() {
				const el = this.$refs.timeShareChart
				if (!el) return
				if (echarts.getInstanceByDom(el)) echarts.dispose(el)
				const chart = echarts.init(el)
				chart.setOption({
					tooltip: {
						trigger: 'axis',
						backgroundColor: '#fff',
						padding: 10,
						borderColor: '#E4E7ED',
						borderWidth: 1,
						textStyle: { color: '#303133', fontSize: 12 },
						extraCssText: 'box-shadow: 0 2px 12px 0 rgba(0,0,0,0.12);',
					},
					grid: { left: '4%', right: '4%', top: '14%', bottom: '6%' },
					xAxis: { type: 'category', data: [] },
					yAxis: [
						{
							type: 'value',
							splitLine: { lineStyle: { type: 'dashed', color: '#DFE6F2' } },
						},
					],
					series: [],
				})
			},
			/**
			 * 根据接口返回的 data 完整渲染分时折线图。
			 * 流程：重置图表实例 → X 轴 hourTime → normalize 多序列 → 图例名（旧双列强制日期标签）→
			 * 多于 3 条线时加大 legend/grid 底部留白 → setOption（滚动图例、率类 Y 轴与 tooltip 格式化）。
			 * @param {object} d 成功响应中的 data，含 hourTime、series 或 first/second
			 */
			applyChartOption(d) {
				const el = this.$refs.timeShareChart
				if (!el) return
				const tooltipBase = {
					trigger: 'axis',
					backgroundColor: '#fff',
					padding: 10,
					borderColor: '#E4E7ED',
					borderWidth: 1,
					textStyle: { color: '#303133', fontSize: 12 },
					extraCssText: 'box-shadow: 0 2px 12px 0 rgba(0,0,0,0.12);',
				}
				const ySplitLine = { lineStyle: { type: 'dashed', color: '#DFE6F2' } }
				const pctLabel = (v) => {
					if (v == null || v === '') return ''
					const s = String(v)
					return s.endsWith('%') ? s : `${s}%`
				}
				const tooltipValue = (v, rate) => {
					if (v == null || v === '') return '-'
					return rate ? pctLabel(v) : v
				}
				const tooltipFormatter = (metricName, rate) => (params) => {
					if (!params || !params.length) return ''
					const tc = '#303133'
					let html = `<div style="font-weight:600;margin-bottom:8px;color:${tc};">${metricName}</div>`
					for (const p of params) {
						html += `<div style="display:flex;align-items:center;justify-content:space-between;min-width:200px;margin:4px 0;color:${tc};">
							<span>${p.marker}<span style="margin-left:6px;">${p.seriesName}</span></span>
							<span style="font-weight:500;color:${p.color};margin-left:16px;">${tooltipValue(p.value, rate)}</span>
						</div>`
					}
					return html
				}
				if (echarts.getInstanceByDom(el)) echarts.dispose(el)
				const chart = echarts.init(el)
				const xData = (d.hourTime || []).map((h) => (h != null && h !== '' ? String(h) : ''))
				const { list: rows, legacyTwoLine, embeddedNames } = this.normalizeChartSeriesArrays(d)
				const metric = this.getChartMetricLabel()
				const isRate = this.labelEndsWithRate(metric)
				let names = this.resolveChartLegendNames(d, rows.length, embeddedNames)
				if (legacyTwoLine && rows.length === 2 && this.datePicker.length === 2) {
					names = [this.buildChartPeriodLabel(1), this.buildChartPeriodLabel(0)]
				}
				const n = rows.length
				const legendBottom = n > 3 ? '12%' : '4%'
				const gridBottom = n > 3 ? '22%' : '16%'
				const colorLast = CHART_LINE_COLORS.length - 1
				const series = rows.map((data, idx) => ({
					name: names[idx],
					type: 'line',
					smooth: 0.5,
					data,
					itemStyle: { color: CHART_LINE_COLORS[Math.min(idx, colorLast)] },
				}))
				chart.setOption({
					tooltip: {
						...tooltipBase,
						axisPointer: { type: 'line' },
						formatter: tooltipFormatter(metric, isRate),
					},
					legend: { type: 'scroll', data: names, bottom: legendBottom },
					grid: { left: '6%', right: '3%', top: '14%', bottom: gridBottom },
					xAxis: { type: 'category', boundaryGap: false, data: xData },
					yAxis: [
						{
							type: 'value',
							name: metric,
							nameTextStyle: { color: '#666666', fontSize: 12 },
							splitLine: ySplitLine,
							axisLabel: isRate ? { formatter: pctLabel } : {},
						},
					],
					series,
				})
			},
			/**
			 * 请求分时图表数据并驱动渲染。
			 * 时间或指标未就绪时画空图；POST timeDataReportChart，code 为 200 或 1 且有 data 时 applyChartOption，否则空图；
			 * 网络异常同样回落到空图，避免残留旧数据误导。
			 */
			async fetchChartData() {
				if (!this.reportQueryTimeReady()) {
					this.renderEmptyChart()
					return
				}
				const chartType = this.chartQueryData.chartColumnChecked
				// const chartType = 'firstProfit'
				if (chartType == null || chartType === '') {
					this.renderEmptyChart()
					return
				}
				const data = this.buildReportQueryBody({
					metric: chartType,
				})
				this.appendTopFilterToReportBody(data)
				try {
					const res = await this.$http.post(this.$api.dataManage.timeDataReportChart,data);
					// 与列表接口一致：成功码为 200 或 1（仅判断 200 时 code:1 会静默走空图）
					if ((res.code == 200 || res.code == 1) && res.data) {
						this.applyChartOption(res.data)
					} else {
						this.renderEmptyChart()
					}
				} catch (e) {
					this.renderEmptyChart()
				}
			},
			/**
			 * el-table 表头渲染钩子：若该列在 sortField 中有缓存排序状态，则写回 column.order，
			 * 以便排序图标与当前 sortField 一致（避免重绘后丢失高亮）。
			 * @param {{ column: object }} 参数对象，column 为 Element UI 表格列上下文
			 */
			handleHeadAddClass({
				column
			}) {
				// console.log(column)
				if (this.sortField[column.property]) {
					column.order = this.sortField[column.property]
				}
			},
			/**
			 * 将表格列 prop 映射为后端排序字段名；未在 sortPropToOrderField 中配置时原样返回 prop。
			 * @param {string} prop 列 property
			 * @returns {string} 接口 orderField
			 */
			mapSortPropToOrderField(prop) {
				const map = this.sortPropToOrderField || {}
				return map[prop] || prop
			},
			/**
			 * 表格列排序变更：维护 sortField（再次点同一方向则清除该列排序），
			 * 汇总为 orderBys（orderField + ASC/DESC），同步 queryApi 并重置到第一页后请求列表。
			 * @param {{ column: object, prop: string, order: string|null }} 参数对象，order 为 ascending/descending/null
			 */
			sortChangeFun({
				column,
				prop,
				order
			}) {
				// 触发的排序和缓存的排序相同时，取消该字段的排序
				if (!order || this.sortField[prop] === order) {
					this.sortField[prop] = null
				} else {
					this.sortField[prop] = order
				}
				this.orderBys = []
				let direction = ''
				for (const i in this.sortField) {
					if (this.sortField[i]) {
						if (this.sortField[i] == 'ascending') {
							direction = 'ASC'
						} else if (this.sortField[i] == 'descending') {
							direction = 'DESC'
						}
						this.orderBys.push({
							"orderField": this.mapSortPropToOrderField(i),
							"orderType": direction
						})
					}
				}
				this.currentPage = 1
				this.queryApi.pageNum = 1
				this.queryApi['adOrderByReqs'] = this.orderBys
				this.getTableData() //调用后端查询接口
			},
			/**
			 * 分页组件每页条数变更：回到第一页，更新本地 pageSize 与 queryApi.pageSize，重新拉表。
			 * @param {number} val 新的 pageSize
			 */
			handleSizeChange(val) {
				this.currentPage = 1
				this.pageSize = val
				this.queryApi.pageNum = 1
				this.queryApi.pageSize = val
				this.getTableData();
			},
			/**
			 * 分页组件当前页变更：更新 currentPage、queryApi.page 并请求列表。
			 * @param {number} val 目标页码
			 */
			handleCurrentChange(val) {
				this.currentPage = val
				this.queryApi.pageNum = val
				this.getTableData();
			},
			/**
			 * 重置筛选：页码与 queryApi 恢复为内置默认（含 type:2 等），重新拉表与图表。
			 * 注意：未在此方法内清空日期/应用/广告位等 UI 状态，是否与产品「重置」语义一致需与需求对齐。
			 */
			searchReset() {
				this.currentPage = 1
				this.queryApi = { 
					pageNum: 1,
					isMedia: true, 
					pageSize: 10, 
					mediaCompany: '',
					mediaAppId: '',
					mediaAdId: '',
					os: '',
					type: '',
					appProperty: ''
				}
				this.getTableData()
				this.fetchChartData()
			},
			// 导出 table 为 Excel（与接口导出命名一致：yyyyMMdd_HHmm + 媒体分时报表对比.xlsx）
			exportToExcelFromDOM() {
				const tableRef = this.$refs.multipleTable
				if (!tableRef || !tableRef.$el) {
					this.$message.warning('表格未就绪')
					return
				}
				const tableEl = tableRef.$el
				const rows = tableEl.querySelectorAll('.el-table__body-wrapper tbody tr')
				const data = []

				const headerEls = tableEl.querySelectorAll('.el-table__header th')
				const headers = Array.from(headerEls).map((th) => th.innerText.trim())
				data.push(headers)
				// const rowData = Array.from(cells).map(cell => {
				// 	// 获取单元格内所有非隐藏元素的文本（包括 v-for 产生的多个 span）
				// 	// 简单做法：取 cell.innerText，它会自动合并所有子元素的文本
				// 	// 如果希望自定义分隔符，可以手动提取各个子元素
				// 	const spans = cell.querySelectorAll('.hobby-tag') // 你的具体 class
				// 	if (spans.length) {
				// 		return Array.from(spans).map(span => span.innerText.trim()).join('、')
				// 	}
				// 	return cell.innerText.trim()
				// })
				rows.forEach((row) => {
					const cells = row.querySelectorAll('td')
					const rowData = Array.from(cells).map((cell) => {
						const spans = cell.querySelectorAll('.updownText')
						if (spans.length) {
							// Excel 单元格内换行使用 \n（CHAR(10)）；与顿号「、」拼接相比，配合行高在表格中更易读
							return Array.from(spans)
								.map((span) => span.innerText.trim())
								.filter(Boolean)
								.join('\n')
						}
						return cell.innerText.trim()
					})
					data.push(rowData)
				})

				const ws = XLSX.utils.aoa_to_sheet(data)
				// this.applyExcelMultilineRowHeights(ws)
				const wb = XLSX.utils.book_new()
				XLSX.utils.book_append_sheet(wb, ws, 'Sheet1')
				const fileName = `${this.getExportFileNamePrefix()}媒体分时报表对比.xlsx`
				XLSX.writeFile(wb, fileName, { cellStyles: true })
			},
			// 根据单元格内换行符数量抬高行高，便于 Excel 中多行展示（仍建议在 Excel 中开启「自动换行」以完全对齐显示）
			applyExcelMultilineRowHeights(ws) {
				const ref = ws['!ref']
				if (!ref) return
				const range = XLSX.utils.decode_range(ref)
				if (!ws['!rows']) ws['!rows'] = []
				for (let R = range.s.r; R <= range.e.r; R++) {
					let maxLines = 1
					for (let C = range.s.c; C <= range.e.c; C++) {
						const addr = XLSX.utils.encode_cell({ r: R, c: C })
						const cell = ws[addr]
						if (!cell || cell.v == null) continue
						const text = String(cell.v)
						const n = (text.match(/\n/g) || []).length
						const lines = n + 1
						if (lines > maxLines) maxLines = lines
					}
					if (maxLines > 1) {
						ws['!rows'][R] = { hpt: Math.min(409, Math.max(15, 14 * maxLines + 6)) }
					}
				}
			},
		},
	}
</script>

<style scoped>
	.searchTop{
		background: #ffffff;
		padding: 20px;
	}
	.el-form {
		align-items: center;
		display: flex;
		justify-content: flex-start;
		flex-wrap: wrap;
		margin-bottom: 25px;
	}
	.searchTop .el-form {
		margin-bottom: 0;
	}

	/deep/ .el-form-item {
		margin-right: 10px !important;
		margin-bottom: 0px;
	}

	.menu-right {
		margin-left: auto;
		/* height: 32px; */
		padding: 4px 0;
		flex-wrap: wrap;
		margin-bottom: -6px;
		/* display: flex;
		flex-direction: column;
		justify-content: space-between; */
	}

	.pagination {
		margin-top: 15px;
	}
	.chart-card{
		/* border: 1px solid #D9D9D9; */
		border-radius: 4px;
		margin: 10px 0;
		background: #ffffff;
		padding: 20px;
	}
	.card-table{
		background: #ffffff;
		padding: 20px;
	}
	.chartTitRow{
		display: flex;
		justify-content: flex-start;
		align-items: center;
		margin-bottom: 20px;
	}
	.chartTitle{
		font-weight: 600;
		font-size: 16px;
		color: #333333;
	}
	.chart-box {
		width: 100%;
		height: 450px;
	}
	.splitTimePicker{
		margin: 0 20px;
		font-size: 14px;
	}
	.el_table{
		/* margin-top: 50px; */
	}
	.paging{
		display: flex;
		justify-content: flex-end;
		margin-top: 20px;
	}
	.menu-right-table{
		margin-bottom: 20px;
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
	.table-header-config{
		display: flex;
		justify-content: flex-start;
		flex-wrap: wrap;
	}
	.table-header-config-toolbar{
		width: 100%;
		margin-bottom: 12px;
		padding-bottom: 10px;
		border-bottom: 1px solid #EBEEF5;
	}
	.table-header-config-item{
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 10px;
		margin-right: 20px;
	}
	.updownText{
		margin-bottom: 10px;
	}
	.tHeadleftTips {
		font-size: 12px;
		margin-right: 20px;
	}
	.tHeadFixedCheckList {
		flex-wrap: wrap;
		width: 50%;
	}

	/deep/.appNameIdOptions .el-select-dropdown__item {
		height: 48px !important;
		line-height: 48px !important;
	}
	.selectTemp2 {
		height: 100%;
		display: flex;
		flex-direction: column;
		justify-content: center;
	}
	.selectAppName,
	.selectAppId {
		font-size: 12px;
		color: #333333;
		line-height: 20px;
	}

	.selectAppId {
		color: #999999;
		align-items: center;
	}

	.selectAppId img {
		width: 14px;
		height: 14px;
		margin-left: 3px;
	}

	.mgb0 {
		margin-bottom: 0 !important;
	}
</style>
